export default "__VITE_ASSET__1203ddb8__"